export const getSubdomain = (subdomainOnly = true) => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
  
    // This logic assumes a single subdomain (e.g., tenant.domain.com).
    // It handles both localhost and the deployed domain correctly.
    // For `localhost:3000`, it will return "localhost" or an empty string, which is fine.
    // For `tenant.nestapp.ai`, it will return "tenant".
    if (parts.length > 2) {
      if(!subdomainOnly){
        return parts[1] + "." + parts[2];
      }
      return parts[0];
    } else {
      // This case handles `yourdomain.com` or `localhost`
      return '';
    }
  };